import React from 'react';

import banner from '../../assets/header-banner.jpg';
import xtramotionLogo from '../../assets/logo.png';
import UserService from '../../services/UserService';

import styles from './Home.module.scss';

const Home: React.FunctionComponent<{}> = () => {
  return (
    <div id="loginpage" className={styles.container}>
      <div className={styles.header}>
        <img className={styles.headerBackground} src={banner} alt="EVS Login" />
      </div>

      <a href="https://www.evs.com" target="_blank" className="login__logo" rel="noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" className="logo-evs" viewBox="0 0 431.5 140.8">
          <path
            className="st0"
            d="M20.1 20H127v20.2H20.1zM20.1 60.3H127v20.2H20.1zM20.1 100.7H127v20.2H20.1zM411.4 40.2V20H304.5v60.5h86.7v20.2h-86.7v20.1h106.9V60.3h-86.8V40.2zM215.7 99.4L169.9 20h-24.8l58.2 100.8h24.8L286.2 20h-24.7z"
          />
        </svg>
      </a>

      <div className="login__wrapper">
        <img src={xtramotionLogo} alt="Xtramotion Eval Platform" className={styles.loginLogoXtramotion} />

        <form id="login-form" action="" className="login__form form js-form">
          <button type="button" className="login_btn" onClick={() => UserService.doLogin()}>
            <span className="login_btn__inner">
              Sign in <i className="evs-icon evs-icon-angle-right" />
            </span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Home;
